import { ReactElement } from 'react';
import { List, ListProps } from 'react-admin';
import { AdminTitle } from '.';

export default function CustomList(
  props: ListProps & { children: ReactElement }
) {
  return (
    <>
      <AdminTitle />
      <List exporter={false} perPage={25} {...props} />
    </>
  );
}
